import { Position } from '../config/models';
import { css } from 'styled-components';
import { CustomColors } from './variables';

export const withBorderCorner = (position = Position.LEFT) => css`
    ${
        !position
            ? ':before, :after, > :first-child:before, > :first-child:after'
            : position === Position.LEFT
            ? ':before, > :first-child:before'
            : ':after, > :first-child:after'
    } {
        position: absolute;
        width: 60px;
        height: 60px;
        border-color: ${CustomColors.secondary};
        border-style: solid;
        content: ' ';
    }

    ${
        !position || position === Position.LEFT
            ? css`
                  :before {
                      top: -18px;
                      left: -18px;
                      border-width: 6px 0 0 6px;
                  }
              `
            : ''
    }

    ${
        !position || position === Position.RIGHT
            ? css`
                  :after {
                      top: -18px;
                      right: -18px;
                      border-width: 6px 6px 0 0;
                  }
              `
            : ''
    }

    ${
        !position || position === Position.LEFT
            ? css`
                  > :first-child:before {
                      bottom: 0;
                      right: 0;
                      border-width: 0 4px 4px 0;
                  }
              `
            : ''
    }

    ${
        !position || position === Position.RIGHT
            ? css`
                  > :first-child:after {
                      bottom: 0;
                      left: 0;
                      border-width: 0 0 4px 4px;
                  }
              `
            : ''
    }
    
`;
